module.exports = __webpack_public_path__ + "img/c4.64a8eaf7.png";